import React from "react";

export enum Gender {
    MALE = 'M',
    FEMALE= 'F',
    NOT_SELECTED = ''
}

export interface GenderSelectionProps {
    gender: Gender,
    onChange: (gender: Gender) => void
}

const GenderSelection: React.FC<GenderSelectionProps> = ({gender, onChange}) => {

    const handleGenderChange = (selectedGender: Gender) => {
        onChange(selectedGender);
    };

    return (
        <div className="profile-input">
            <label className="font-12 d-block profile-input-label">
                Gender <span className="text-danger">*</span>
            </label>
            <div className="gender-selection">
                {/* Male Button */}
                <button
                    type="button"
                    className={`gender-option ${gender === "M" ? "selected" : ""}`}
                    onClick={() => handleGenderChange(Gender.MALE)}
                >
                    Male
                </button>

                {/* Female Button */}
                <button
                    type="button"
                    className={`gender-option ${gender === "F" ? "selected" : ""}`}
                    onClick={() => handleGenderChange(Gender.FEMALE)}
                >
                    Female
                </button>
            </div>
        </div>
    );
};

export default GenderSelection;